<template>
  <div v-if="info.name">
    <h4 class="font-weight-bold">{{ info.name }}</h4>
    <h4 class="pt-2 font-weight-bold text-danger" v-show="localCurrency">
      SC$ {{ priceSacoinWDiscount }}
      <div class="mb-3 d-inline">
        <span class="text-muted">
          <small
            >({{ info.currency == "USA" ? "USD" : info.currency }}$
            {{ priceWDiscount }})</small
          >
        </span>
        <small class="pl-2">[CRR: {{ info.category.crr }}%]</small>
      </div>
      <div :class="info.discount ? 'd-inline' : 'd-none'">
        <span class="badge badge-success ml-3">{{ info.discount }}% off</span>
        <div class="old-price">
          SC$ {{ priceSacoin }}
          <div class="d-inline">
            <span class="text-muted">
              <small class="my-auto"
                >({{ info.currency == "USA" ? "USD" : info.currency }}$
                {{ price }})</small
              >
            </span>
          </div>
        </div>
      </div>
    </h4>
    <div>
      <p>
        Categoria:
        <span v-if="info.category">
          <router-link
            :to="{
              name: 'ProductsByCategory',
              params: {
                category: info.category.name
                  .replace(/\-/g, '_')
                  .replace(/\s/g, '-'),
              },
            }"
            >{{ info.category.name }}</router-link
          >
        </span>
        <span v-else>-</span>
      </p>
      <p>
        Vendedor:
        <b>{{ info.sellerId ? info.sellerId.username : "" }}</b>
      </p>
      <div>
        <p v-if="info.sellerPlaces.length > 0 && info.CityOfSale == ''">
          Envíos a:
          <span
            v-for="country in listCountries"
            :key="country"
            class="badge badge-dark mr-1 p-2"
            >{{ country }}</span
          >
        </p>
        <p v-if="info.sellerPlaces.length == 1 && info.CityOfSale">
          Ciudad de venta:
          <span class="badge badge-dark mr-1 p-2"
            >{{ info.CityOfSale }} - {{ listCountries[0] }}</span
          >
          <span class="badge badge-info mr-1 p-2" v-if="info.shippingType == 2"
            >Recoger en domicilio</span
          >
          <span class="badge badge-info mr-1 p-2" v-else
            >Envío a domicilio</span
          >
        </p>
        <p v-if="info.sellerPlaces.length == 0">
          Envíos a:
          <span class="badge badge-dark mr-1 p-2" v-if="info.shippingType != 2"
            >Todo el mundo!</span
          >
        </p>
      </div>
      <p>
        Cantidad:
        <input
          type="number"
          class="form-control mr-3"
          id="amount-input"
          :max="info.amount"
          min="1"
          value="1"
        />
        <span class="text-muted">(Disponible: {{ info.amount }})</span>
      </p>
      <p v-for="(option, i) in info.options" :key="`opt-${i}`">
        {{ option.form.name }}:
        <select
          class="form-control d-inline-block w-auto"
          v-model="option.value"
        >
          <option v-for="(opt, j) in option.options" :key="`subOpt${i}-${j}`">
            {{ opt }}
          </option>
        </select>
      </p>
    </div>
    <div class="row">
      <div class="col-6">
        <span
          class="btn btn-block text-uppercase"
          @click="handleAddItemCart"
          :class="canAddToCart ? 'btn-treid' : 'btn-secondary'"
          >agregar a carrito</span
        >
      </div>
    </div>
    <ModalAddItemCart
      v-on:close="closeModal"
      :item="info.name"
      :visible="modalVisble"
    />
    <ModalAddItemCartError
      v-on:close="closeModalError"
      v-on:send="clearCart"
      :item="info.name"
      :seller="info.sellerId.name"
      :sellerCart="cart.seller.name"
      :visible="modalVisbleError"
      :text="modalText"
    />
  </div>
  <div v-else style="overflow: hidden">
    <SkeletonTitle :width="75" />
    <SkeletonTitle :width="25" />
    <SkeletonTitle :width="50" />
    <SkeletonTitle :width="50" />
    <SkeletonTitle :width="25" />
    <SkeletonBtn class="my-4" />
  </div>
</template>

<script>
import SkeletonTitle from "../skeletons/SkeletonTitle";
import SkeletonBtn from "../skeletons/SkeletonBtn";
import ModalAddItemCart from "@/components/modals/ModalAddItemCart.vue";
import ModalAddItemCartError from "@/components/modals/ModalAddItemCartError.vue";
import { mapState, mapMutations } from "vuex";
import { LC } from "../../tools/exchange";
export default {
  name: "InfoGeneralProduct",
  props: {
    listCountries: {
      type: Array,
      default: () => [],
    },
    info: Object,
    changes: Object,
    kind: {
      type: String,
      default: "product",
    },
  },
  data() {
    return {
      modalVisble: false,
      modalVisbleError: false,
      localCurrency: null,
      modalText: "DIFFERENT_SELLER",
    };
  },
  components: {
    SkeletonTitle,
    SkeletonBtn,
    ModalAddItemCart,
    ModalAddItemCartError,
  },
  methods: {
    ...mapMutations(["setItemCart", "clearItemCart"]),
    clearCart() {
      this.clearItemCart();
      this.closeModalError();
      this.cart.seller = {
        id: 0,
        name: "",
      };
    },

    closeModal() {
      this.modalVisble = false;
    },
    closeModalError() {
      this.modalVisbleError = false;
    },
    handleAddItemCart() {
      this.modalText = "DIFFERENT_SELLER";
      let kind = null;

      if (this.cart.items.length) {
        for (const product of this.cart.items) {
          if (!kind) kind = product.kind;

          if (kind != product.kind) {
            this.modalVisbleError = true;
            this.modalText = "DIFFERENT_KIND";
            return;
          }
        }

        if (kind != this.kind) {
          this.modalVisbleError = true;
          this.modalText = "DIFFERENT_KIND";
          return;
        }
      }

      let options = this.info.options.map((e) => {
        return { _id: e._id, form: e.form, value: e.value };
      });
      let _ = {
        seller: {
          id: this.info.sellerId._id,
          name: this.info.sellerId.username,
        },
        item: {
          id: this.$route.params.id,
          amount: 1,
          kind: this.kind,
          options,
        },
      };

      if (
        this.cart.seller.id &&
        this.cart.seller.id != this.info.sellerId._id
      ) {
        this.modalVisbleError = true;
      } else {
        this.setItemCart(_);
        this.modalVisble = true;
      }
    },
  },
  created: function () {
    LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });
  },
  computed: {
    ...mapState(["cart"]),
    priceSacoinWDiscount() {
      if (!this.localCurrency) return 0;
      const discount = 1 - this.info.discount / 100;
      return (
        this.localCurrency.localToSC({
          price: this.info.price,
          currency: this.info.currency,
        }) * discount
      ).toFixed(2);
    },
    price() {
      return this.info.price.toFixed(2);
    },
    priceWDiscount() {
      const discount = 1 - this.info.discount / 100;
      return (this.info.price * discount).toFixed(2);
    },
    priceSacoin() {
      if (!this.localCurrency) return 0;
      return this.localCurrency
        .localToSC({
          price: this.info.price,
          currency: this.info.currency,
        })
        .toFixed(2);
    },
    canAddToCart() {

      if (!this.cart.items.length) return true;

      if (!this.cart.seller.id) return true;

      if (this.cart.seller.id != this.info.sellerId._id) return false;

      let kind = null;

      for (const product of this.cart.items) {
        if (!kind) kind = product.kind;

        if (kind != product.kind) return false;
      }

      return kind == this.kind;
    },
  },
};
</script>

<style scoped>
#amount-input {
  width: 4em;
  display: inline;
}

/* number inputs with arrows always visible */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}

.old-price {
  text-decoration: line-through;
  font-size: 0.8em;
}

.old-price div {
  margin-left: 0.5em;
  text-decoration: line-through;
  text-decoration-color: grey;
  font-size: 0.8em;
}
</style>